
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TrendingUp, Building2, HardHat } from "lucide-react";
import { formatCurrency } from "@/lib/utils";
import { WorkspaceAnalytics } from "@/types/workspace";
import { AnimatedCounter } from "./AnimatedCounter";

interface TotalRCVCardProps {
    analytics: WorkspaceAnalytics;
}

export function TotalRCVCard({ analytics }: TotalRCVCardProps) {
    return (
        <Card className="relative overflow-hidden border-0 bg-gradient-to-br from-indigo-500/10 via-white to-indigo-600/5 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 h-full flex flex-col">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-indigo-500/20 to-transparent rounded-full -translate-x-8 -translate-y-8 blur-2xl" />
            <CardHeader className="pb-2 relative">
                <CardTitle className="text-sm font-medium flex items-center gap-2 text-foreground/80">
                    <div className="p-2 bg-indigo-500/20 rounded-lg">
                        <TrendingUp className="h-4 w-4 text-indigo-600" />
                    </div>
                    Total RCV Difference
                </CardTitle>
            </CardHeader>
            <CardContent className="relative space-y-2">
                <div className="text-2xl font-bold text-indigo-700">
                    <AnimatedCounter
                        value={analytics.totalRCVDifference || 0}
                        format={formatCurrency}
                    />
                </div>
                <div className="space-y-1 text-xs">
                    <div className="flex justify-between items-center group">
                        <span className="text-muted-foreground flex items-center gap-1">
                            <Building2 className="h-3 w-3 opacity-50" />
                            Insurance RCV:
                        </span>
                        <span className="font-medium text-blue-600">
                            {formatCurrency(analytics.totalInsuranceRCV || 0)}
                        </span>
                    </div>
                    <div className="flex justify-between items-center group">
                        <span className="text-muted-foreground flex items-center gap-1">
                            <HardHat className="h-3 w-3 text-orange-500" />
                            Contractor RCV:
                        </span>
                        <span className="font-medium text-orange-600">
                            {formatCurrency(analytics.totalContractorRCV || 0)}
                        </span>
                    </div>
                    {(analytics.averageVarianceAmount !== undefined ||
                        analytics.averageVariancePercent !== undefined) && (
                            <div className="flex justify-between items-center group mt-2 pt-2 border-t border-border">
                                <span className="text-muted-foreground flex items-center gap-1">
                                    <TrendingUp className="h-3 w-3 opacity-50" />
                                    Avg Variance:
                                </span>
                                <span className="font-medium text-indigo-600">
                                    {analytics.averageVarianceAmount !== undefined
                                        ? `${formatCurrency(
                                            analytics.averageVarianceAmount
                                        )} (${analytics.averageVariancePercent?.toFixed(1) ||
                                        "0"
                                        }%)`
                                        : "N/A"}
                                </span>
                            </div>
                        )}
                </div>
            </CardContent>
        </Card>
    );
}
